/* global google */
import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import {Alert, Button, Container, Form, FormGroup, FormFeedback, Input, Label, Col, Row} from 'reactstrap';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import 'whatwg-fetch';

var recaptchaInstance;

export default class ContactContent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone: "",
      message: "",
      prefersEmail: false,
      prefersPhone: false,
      captcha: "",
      nameValidated: false,
      emailValidated: false,
      phoneValidated: false,
      messageValidated: false,
      captchaValidated: false,
      allButCaptchaValidated: false,
      formCanSubmit: false,
      formSubmitFailed: false,
      formSubmitted: false
    };
  }

  setInputState = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    }, function() { this.setValidationState(); });
  }

  setCaptchaState = (value) => {
    // If user correctly solves captcha, then sits idle, it will become null. Reset it in that case.
    if(value == null) {
      recaptchaInstance.reset();
      this.setState({
         captcha: ""
      }, function () { this.setValidationState(); });
    }
    else {
      this.setState({
         captcha: value
      }, function () { this.setValidationState(); });
    }
  }

  canFormSubmit = () => {
    var allButCaptchaValidated = false;
    var formCanSubmit = false;

  this.state.nameValidated && this.state.emailValidated && 
  this.state.phoneValidated &&
  this.state.messageValidated
  ? allButCaptchaValidated = true : allButCaptchaValidated = false;

  this.state.nameValidated && this.state.emailValidated && 
  this.state.phoneValidated &&
  this.state.messageValidated && this.state.captchaValidated 
  ? formCanSubmit = true : formCanSubmit = false;

  this.setState({
    allButCaptchaValidated: allButCaptchaValidated,
    formCanSubmit: formCanSubmit
    });
  }

  setValidationState = () => {
    const name = this.state.name;
    const email = this.state.email;
    const phone = this.state.phone;
    const message = this.state.message;
    const captcha = this.state.captcha;

    var nameValidated = false;
    var emailValidated = false;
    var phoneValidated = false;
    var messageValidated = false;
    var captchaValidated = false;
  
    name.length > 0 && name != null ? nameValidated = true : nameValidated = false;
    this.validateEmail(email) ? emailValidated = true : emailValidated = false;
    this.validatePhone(phone) ? phoneValidated = true : phoneValidated = false;
    message.length > 0 && message != null ? messageValidated = true : messageValidated = false;
    captcha.length > 0 && captcha != null ? captchaValidated = true : captchaValidated = false;

    this.setState({
        nameValidated: nameValidated,
        emailValidated: emailValidated,
        phoneValidated: phoneValidated,
        messageValidated: messageValidated,
        captchaValidated: captchaValidated
    }, function () { this.canFormSubmit(); });
  }

  submitForm = () => {
    const name = this.state.name;
    const email = this.state.email;
    const phone = this.state.phone;
    const message = this.state.message;
    const prefersEmail = this.state.prefersEmail;
    const prefersPhone = this.state.prefersPhone;
    const captcha = this.state.captcha;

    const currentFields = "Name: " + name + this.state.nameValidated +
      "\nEmail: " + email + this.state.emailValidated + "\nPhone: " + phone + this.state.phoneValidated +
      "\nMessage: " + message + this.state.messageValidated +
      "\nP_Email: " + prefersEmail + "\nP_Phone: " + prefersPhone +
      "\nCaptcha: " + captcha + this.state.captchaValidated;

      this.state.formCanSubmit
      ? this.successfulFormSubmit(currentFields)
      : this.failedFormSubmit()
  }

  successfulFormSubmit(currentFields) {
    //console.log("Submitting the following: " + currentFields);
    this.sendEmail();
    recaptchaInstance.reset();

    this.setState({
      formSubmitted: true,
      formSubmitFailed: false,
      formCanSubmit: false,
        name: "",
        email: "",
        phone: "",
        message: "",
        prefersEmail: false,
        prefersPhone: false,
        captcha: "",
        nameValidated: false,
        emailValidated: false,
        phoneValidated: false,
        messageValidated: false,
        captchaValidated: false,
        allButCaptchaValidated: false,
    });

  }
  failedFormSubmit = () => {
    console.log("One or more fields have an error. Please enter values according to the errors given above.")

    this.setState({
      formSubmitted: false,
      formSubmitFailed: true
    });
  }

  sendEmail = () => {
    var URL = 'https://y80ewecumi.execute-api.us-east-1.amazonaws.com/prod/message';
         
    var emailData = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
      prefersEmail: this.state.prefersEmail,
      prefersPhone: this.state.prefersPhone
    };

    fetch(URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      body: JSON.stringify({emailData})
    })
    .then(function (response) {
      //console.log('Response: ' + response.json());
    })
    .then(function (result) {
      //console.log('Result: ' + result);
    })
    .catch(function(error) {
      //console.log('Error: ' + error);
    });
  }

  validateEmail = (value) => {
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(value);
  }
  validatePhone = (value) => {
    var validated = false;
    if(value.length > 6 && value.length < 20)
    {
      return value.match(/\d/g);
    }

    return validated;
  }



  render () {
  	return (
      <Container_s fluid>
        <Container_1000>
          <h2>Contact Us!</h2>
          <h3>Fill out the following information, and we will get back to you shortly</h3>
          <hr />
          <Form_s>
            <FormGroup row>
              <Col xs="12" md="4" 
                  className={this.state.formSubmitFailed && !this.state.nameValidated ? "has-danger" : ""}>
                <Input name="name" placeholder="Name" 
                  state={this.state.formSubmitFailed && !this.state.nameValidated ? "danger" : ""}
                  value={this.state.name} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.nameValidated ? 'block' : 'none'}}>
                  Please enter your name.
                </FormFeedback>
              </Col>
              <Col xs="12" md="4"
                className={this.state.formSubmitFailed && !this.state.emailValidated ? "has-danger" : ""} >
                <Input name="email" type="email" placeholder="Email Address" 
                  state={this.state.formSubmitFailed && !this.state.emailValidated ? "danger" : ""}
                  value={this.state.email} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.emailValidated ? 'block' : 'none'}}>
                  Please enter your email address.
                </FormFeedback>
              </Col>
              <Col xs="12" md="4"
                className={this.state.formSubmitFailed && !this.state.phoneValidated ? "has-danger" : ""} >
                <Input name="phone" placeholder="Phone Number" 
                  state={this.state.formSubmitFailed && !this.state.phoneValidated ? "danger" : ""}
                  value={this.state.phone} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.phoneValidated ? 'block' : 'none'}}>
                  Please enter your phone number.
                </FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col xs="12" md="12"
                className={this.state.formSubmitFailed && !this.state.messageValidated ? "has-danger" : ""} >
                <Input name="message" placeholder="Question or Message" type="textarea"
                  state={this.state.formSubmitFailed && !this.state.messageValidated ? "danger" : ""}
                  value={this.state.message} onChange={this.setInputState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.messageValidated ? 'block' : 'none'}}>
                  Please enter the question or message you would like to send us.
                </FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup row className="mt-3">
              <Col xs="5" sm="5" md="5" lg="4">
                <p>How would you prefer to be contacted?</p>
              </Col>
              <Col xs="3" sm="2" md="2" lg="1">
                <FormGroup check>
                  <Label check for="cbEmail" style={{padding: "0"}}>
                    <Input type="checkbox" id="cbEmail" checked={this.state.prefersEmail} 
                      onClick={ () => { this.setState({prefersEmail: !this.state.prefersEmail}); }}  /> 
                    {' '} Email
                  </Label>
                </FormGroup>
              </Col>
              <Col xs="4" sm="3" md="2" lg="1">
                <FormGroup check>
                  <Label check for="cbPhone" style={{padding: "0"}}>
                    <Input type="checkbox" id="cbPhone" checked={this.state.prefersPhone}
                      onClick={ () => { this.setState({prefersPhone: !this.state.prefersPhone}); }}  /> 
                    {' '} Phone
                  </Label>
                </FormGroup>
              </Col>
            </FormGroup>
            <FormGroupLast row>
              <CaptchaCol xs="12"
                className={this.state.formSubmitFailed && !this.state.captchaValidated &&
                       this.state.allButCaptchaValidated ? "has-danger" : ""} >
                <ReCAPTCHA id="captcha"
                  style={{display: !this.state.allButCaptchaValidated ? 'none' : 'block'}}
                  ref={e => recaptchaInstance = e}
                  sitekey="6LeI5TcUAAAAAAPopTDYm-wcAlcgMgDzSvGu5Yhi"
                  onChange={this.setCaptchaState} />
                <FormFeedback style={{display: this.state.formSubmitFailed && !this.state.captchaValidated && 
                                      this.state.allButCaptchaValidated ? 'block' : 'none'}}>
                  Please successfully complete the captcha.
                </FormFeedback>
              </CaptchaCol>
              <SendBtnCol xs="12">
                <Button type="button" onClick={this.submitForm} color="primary" size="lg">
                  SEND
                </Button>
              </SendBtnCol>
            </FormGroupLast>
            <FormGroupSubmissionResultRow row className="mb-0">
              <Col xs="12">
                <p style={{display: !this.state.formSubmitted ? 'none' : 'block'}} className="text-success">
                  Message has been sent successfully. Thank you!</p>
                <p style={{display: !this.state.formSubmitFailed ? 'none' : 'block'}} className="text-danger">
                  One or more fields have not been filled out correctly. 
                  Please review them and try to send again.</p>
              </Col>
            </FormGroupSubmissionResultRow>
          </Form_s>
        </Container_1000>
      </Container_s>
  	);
  }
}


const FormGroupSubmissionResultRow = styled(FormGroup)`
  text-align: center;
`;
const CaptchaCol = styled(Col)`
    padding: 0;
    margin: 20px 15px 0 15px;
    transform: scale(0.77);
    transform-origin: 0 0;
`;
const SendBtnCol = styled(Col)`
  Button {
      background-color: #996633;
      border: none;
      box-shadow: none;
      width: 150px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      line-height: 21px;

      &:hover {
        background: #dfbf9f;
      }
      &:focus {
        box-shadow: none;
      }
      &:active {
        background: #dfbf9f;
      }
  }
`;
const FormGroupLast = styled(FormGroup)`
    margin-bottom: 0;
    padding-bottom: 15px;
`;

const Form_s = styled(Form)`
    text-align: left;
    font-size: 18px;
    margin-top: 60px;

    .row {
      margin-bottom: 0;
      
      .col-12 {
        margin-bottom: 10px;

        input, textarea {
          border-style: none none solid none;
          border-color: black black black black;
          border-radius: 0;
          background-color: transparent;
          padding-left: 0;
          font-family: 'Raleway';
          font-size: 18px;
          :-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:active, :-webkit-autofill:focus { transition: background-color 5000s ease-in-out 0s; }
          box-shadow: none;

          &::placeholder {
            color: black;
          }
        } 
      }
    }
`;


const Container_s = styled(Container)`
  padding: 0!important;
  padding-top: 10px!important;
  margin-bottom: 30px;
`;

const Container_1000 = styled(Container)`
  max-width: 1000px;
  text-align: center;
  color: black;
  margin: 0 auto!important;


  h2,h3 {
    color: #76451F;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin: 10px 15px 10px 15px;
  }
  h3 {
    color: black;
    font-size: 15px;
    ${media.lg` font-size: 17px; `}
    margin-bottom: 20px;
  }
  p {
    font-family: 'Raleway';
  }
  hr {
    border-top: 1.1px solid #8A572A;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Contact.js